import { NormalizedFeatures } from '@ww-digital/xs-sdk';

const allowedTestIDs = [
  'XS-Template--GREX-229',
  'XS-Template--WPF-1005',
  'XS-Template--WPF-1085',
  'XS-Template--WPF-1155-V1FC',
  'XS-Template--WPF-1156',
  'XS-Template--WPF-1157',
  'XS-Template--WPF-1258',
  'XS-Template--WPF-652-fc',
  'XS-Template--WPF-685',
  'XS-Template--WPF-927',
  'XS-Template--WPF-985-V1W',
  'XS-Template--WPF-982-RL2',
  'XS-Template--WPF-982-Exclusion3',
  'XS-Template--WPF-973',
  'XS-Template--WPF-878-R3',
  'XS-Template--WPF-903',
  'XS-Template--WPF-945-Alt',
  'XS-Template--WPF-973',
];

export const filterExperimentTextIDs = (
  normalizedFeatures: NormalizedFeatures,
  queryString: Record<string, string>,
  activeTestStatus: boolean,
): string[] => {
  const normExpTextIDs = Object.keys(normalizedFeatures);

  return normExpTextIDs.filter((expTextId) =>
    !queryString.exptextid && !queryString.varid && !queryString.xspreviewtests
      ? (expTextId.includes('XS_TEMPLATE__') ||
          allowedTestIDs.includes(expTextId)) &&
        normalizedFeatures[expTextId]?.enabled === activeTestStatus
      : expTextId.includes('XS_TEMPLATE__') ||
        allowedTestIDs.includes(expTextId),
  );
};
